import type { WorkplaceReminderDeepLink, WorkplaceReminderViewModel } from "@/lib/messages/workplaceReminderModel";
import { WorkplaceReminderCard } from "./WorkplaceReminderCard";
import type { ReassignMemberOption } from "./WorkplaceReminderHygieneActions";

export type WorkplaceRemindersListProps = {
  reminders: WorkplaceReminderViewModel[];
  compact?: boolean;
  emptyLabel?: string;
  canReassign?: boolean;
  reassignMembers?: ReassignMemberOption[];
  onDismiss?: (notificationId: string) => void;
  onAcknowledge?: (notificationId: string) => void;
  onResolve?: (notificationId: string, reason?: string) => void;
  onReassign?: (notificationId: string, assigneeUserId: string, reason?: string) => void;
  onNavigate?: (link: WorkplaceReminderDeepLink) => void;
};

export function WorkplaceRemindersList({
  reminders,
  compact,
  emptyLabel,
  canReassign,
  reassignMembers,
  onDismiss,
  onAcknowledge,
  onResolve,
  onReassign,
  onNavigate,
}: WorkplaceRemindersListProps) {
  if (reminders.length === 0) {
    return emptyLabel ? <p className="text-[11px] text-gray-500 dark:text-gray-400">{emptyLabel}</p> : null;
  }
  return (
    <ul className={`space-y-2 ${compact ? "" : "mt-1"}`}>
      {reminders.map((r) => (
        <li key={r.id}>
          <WorkplaceReminderCard
            reminder={r}
            compact={compact}
            canReassign={canReassign}
            reassignMembers={reassignMembers}
            onDismiss={onDismiss}
            onAcknowledge={onAcknowledge}
            onResolve={onResolve}
            onReassign={onReassign}
            onNavigate={onNavigate}
          />
        </li>
      ))}
    </ul>
  );
}
